import PropTypes from 'prop-types';

export const mdStatePropType = PropTypes.shape({
    formulas: PropTypes.object,
    resources: PropTypes.object,
});
